// extracted by mini-css-extract-plugin
export default {"Restaurant__RestaurantSelector":"Restaurant_Restaurant__RestaurantSelector__gtpkV"};